// Keto Vybe - Premium Keto Supplements
// Bold, modern e-commerce store

// ============================================
// SITE IMAGES - Premium Fitness/Wellness Theme
// ============================================
export const siteImages = {
  // Hero images - premium lifestyle
  heroMain: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=1920&q=85',
  heroSecondary: 'https://images.unsplash.com/photo-1607962837359-5e7e89f86776?w=1920&q=85',
  heroLifestyle: 'https://images.pexels.com/photos/4971081/pexels-photo-4971081.jpeg?auto=compress&cs=tinysrgb&w=1920&q=80',
  
  // Section backgrounds
  ctaBackground: 'https://images.unsplash.com/photo-1714329078995-ce3ac475d201?w=1920&q=85',
  featuredBackground: 'https://images.unsplash.com/photo-1693996047008-1b6210099be1?w=1920&q=85',
  lifestyleSection: 'https://images.unsplash.com/photo-1607962837359-5e7e89f86776?w=1920&q=85',
  
  // Page banners
  shopBanner: 'https://images.unsplash.com/photo-1693996047008-1b6210099be1?w=1920&q=85',
  aboutBanner: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=1920&q=85',
  contactBanner: 'https://images.unsplash.com/photo-1714329078995-ce3ac475d201?w=1920&q=85',
  returnsBanner: 'https://images.unsplash.com/photo-1693996046514-0406d0773a7d?w=1920&q=85',
  privacyBanner: 'https://images.unsplash.com/photo-1607962837359-5e7e89f86776?w=1920&q=85',
  
  // Category images - Use branded product images
  ketoSupplements: 'https://customer-assets.emergentagent.com/job_wellness-redesign-8/artifacts/ita0vwvz_BHB%20Ketone%20Capsules%20-%20Advanced%20Formula.png',
  fatBurners: 'https://customer-assets.emergentagent.com/job_wellness-redesign-8/artifacts/f2q9fu1u_Thermogenic%20Fat%20Burner%20Complex.png',
  energyBoost: 'https://customer-assets.emergentagent.com/job_wellness-redesign-8/artifacts/gtu7q8s4_Keto%20Energy%20Boost%20Capsules.png',
  digestiveHealth: 'https://customer-assets.emergentagent.com/job_wellness-redesign-8/artifacts/d9ydic4y_Keto%20Probiotics%2040%20Billion%20CFU.png',
  vitamins: 'https://customer-assets.emergentagent.com/job_wellness-redesign-8/artifacts/it2bigg2_Vitamin%20D3%20%2B%20K2%20Complex%20.png',
  wellness: 'https://customer-assets.emergentagent.com/job_wellness-redesign-8/artifacts/mmfcjdm1_Keto%20Sleep%20Support%20Formula%20.png',
};

// ============================================
// PRODUCT IMAGES - Keto Supplements (Custom Branded Images)
// ============================================
const productImages = {
  bhbKetones: 'https://customer-assets.emergentagent.com/job_wellness-redesign-8/artifacts/ita0vwvz_BHB%20Ketone%20Capsules%20-%20Advanced%20Formula.png',
  ketoElectrolytes: 'https://customer-assets.emergentagent.com/job_wellness-redesign-8/artifacts/890z56jd_Keto%20Electrolyte%20Complex.png',
  thermogenicBlend: 'https://customer-assets.emergentagent.com/job_wellness-redesign-8/artifacts/f2q9fu1u_Thermogenic%20Fat%20Burner%20Complex.png',
  mctoilCapsules: 'https://customer-assets.emergentagent.com/job_wellness-redesign-8/artifacts/lzqggtlg_MCT%20Oil%20Softgels%203000mg.png',
  ketoEnergyPills: 'https://customer-assets.emergentagent.com/job_wellness-redesign-8/artifacts/gtu7q8s4_Keto%20Energy%20Boost%20Capsules.png',
  brainBooster: 'https://customer-assets.emergentagent.com/job_wellness-redesign-8/artifacts/mwqx6zo9_Brain%20Fuel%20Nootropic%20Blend.png',
  probioticsKeto: 'https://customer-assets.emergentagent.com/job_wellness-redesign-8/artifacts/d9ydic4y_Keto%20Probiotics%2040%20Billion%20CFU.png',
  digestiveEnzymes: 'https://customer-assets.emergentagent.com/job_wellness-redesign-8/artifacts/ah80m36u_Digestive%20Enzyme%20Complex.png',
  ketoMultivitamin: 'https://customer-assets.emergentagent.com/job_wellness-redesign-8/artifacts/tek97gyi_Complete%20Keto%20Multivitamin.png',
  vitaminD3K2: 'https://customer-assets.emergentagent.com/job_wellness-redesign-8/artifacts/it2bigg2_Vitamin%20D3%20%2B%20K2%20Complex%20.png',
  sleepSupport: 'https://customer-assets.emergentagent.com/job_wellness-redesign-8/artifacts/mmfcjdm1_Keto%20Sleep%20Support%20Formula%20.png',
  immuneBoost: 'https://customer-assets.emergentagent.com/job_wellness-redesign-8/artifacts/v5xlvq6e_Keto%20Electrolyte%20Complex.png',
};

export const SHIPPING_NOTICE = 'Free USA Shipping on $99+';
export const SHIPPING_COUNTRIES = ['US'];
export const SHIPPING_METHOD = 'USPS';
export const SHIPPING_TIME = '3-5 business days';
export const FREE_SHIPPING_THRESHOLD = 99;

// Card Statement Descriptor
export const CARD_DESCRIPTOR = 'KETO VYBE';

// Contact Info - Keto Vybe
export const CONTACT_INFO = {
  phone: '(866) 938-8087',
  email: 'support@ketovybe.com',
  corpName: 'LP Capital Holdings LLC',
  address: {
    street: '1634 Tara Ct',
    city: 'Lancaster',
    state: 'CA',
    zip: '93535',
    country: 'USA'
  }
};

// Return Address
export const RETURN_ADDRESS = {
  street: '1634 Tara Ct',
  city: 'Lancaster',
  state: 'CA',
  zip: '93535',
  country: 'USA'
};

// ============================================
// CATEGORIES - Keto Supplements
// ============================================
export const categories = [
  {
    id: 'keto-essentials',
    name: 'Keto Essentials',
    slug: 'keto-essentials',
    description: 'Core supplements for ketosis support',
    image: siteImages.ketoSupplements,
    productCount: 2
  },
  {
    id: 'fat-burners',
    name: 'Fat Burners',
    slug: 'fat-burners',
    description: 'Boost metabolism and burn fat',
    image: siteImages.fatBurners,
    productCount: 2
  },
  {
    id: 'energy-focus',
    name: 'Energy & Focus',
    slug: 'energy-focus',
    description: 'Mental clarity and sustained energy',
    image: siteImages.energyBoost,
    productCount: 2
  },
  {
    id: 'digestive-health',
    name: 'Digestive Health',
    slug: 'digestive-health',
    description: 'Probiotics and enzymes for gut health',
    image: siteImages.digestiveHealth,
    productCount: 2
  },
  {
    id: 'vitamins-minerals',
    name: 'Vitamins & Minerals',
    slug: 'vitamins-minerals',
    description: 'Essential nutrients for keto',
    image: siteImages.vitamins,
    productCount: 2
  },
  {
    id: 'wellness-blends',
    name: 'Wellness Blends',
    slug: 'wellness-blends',
    description: 'Sleep, immunity, and overall wellness',
    image: siteImages.wellness,
    productCount: 2
  },
  {
    id: 'bundles-value-packs',
    name: 'Bundles & Value Packs',
    slug: 'bundles-value-packs',
    description: 'Premium multi-month bundles & wholesale packs',
    image: siteImages.ketoSupplements,
    productCount: 6
  }
];

// ============================================
// PRODUCTS - 12 Products (2 per category)
// ============================================
export const products = [
  {
    id: 'bhb-ketone-capsules',
    name: 'BHB Ketone Capsules - Advanced Formula',
    slug: 'bhb-ketone-capsules',
    sku: 'KV-KE-001',
    price: 54.95,
    image: productImages.bhbKetones,
    badge: 'Best Seller',
    categoryId: 'keto-essentials',
    categorySlug: 'keto-essentials',
    description: 'Premium BHB ketone capsules to support ketosis. Boost energy and mental clarity.',
    features: ['Exogenous Ketones', 'Supports Ketosis', 'Energy Boost', 'Mental Clarity'],
    inStock: true
  },
  {
    id: 'keto-electrolyte-complex',
    name: 'Keto Electrolyte Complex',
    slug: 'keto-electrolyte-complex',
    sku: 'KV-KE-002',
    price: 19.75,
    image: productImages.ketoElectrolytes,
    categoryId: 'keto-essentials',
    categorySlug: 'keto-essentials',
    description: 'Essential electrolytes for ketogenic diet. Combat keto flu and stay hydrated.',
    features: ['Sodium & Potassium', 'Magnesium Blend', 'Keto Flu Relief', 'No Added Sugar'],
    inStock: true
  },
  {
    id: 'thermogenic-fat-burner',
    name: 'Thermogenic Fat Burner Complex',
    slug: 'thermogenic-fat-burner',
    sku: 'KV-FB-001',
    price: 62.50,
    image: productImages.thermogenicBlend,
    badge: 'Popular',
    categoryId: 'fat-burners',
    categorySlug: 'fat-burners',
    description: 'Powerful thermogenic formula to accelerate metabolism and support fat burning.',
    features: ['Boosts Metabolism', 'Green Tea Extract', 'L-Carnitine', 'Appetite Support'],
    inStock: true
  },
  {
    id: 'mct-oil-softgels',
    name: 'MCT Oil Softgels 3000mg',
    slug: 'mct-oil-softgels',
    sku: 'KV-FB-002',
    price: 36.80,
    image: productImages.mctoilCapsules,
    categoryId: 'fat-burners',
    categorySlug: 'fat-burners',
    description: 'Pure MCT oil in convenient softgel form. Instant energy and ketone production.',
    features: ['3000mg MCT Oil', 'Instant Energy', 'Ketone Production', 'Easy to Take'],
    inStock: true
  },
  {
    id: 'keto-energy-boost',
    name: 'Keto Energy Boost Capsules',
    slug: 'keto-energy-boost',
    sku: 'KV-EF-001',
    price: 42.25,
    image: productImages.ketoEnergyPills,
    badge: 'New',
    categoryId: 'energy-focus',
    categorySlug: 'energy-focus',
    description: 'All-natural energy formula for keto lifestyle. Sustained energy without jitters.',
    features: ['Clean Energy', 'No Jitters', 'B-Vitamin Complex', 'Adaptogenic Herbs'],
    inStock: true
  },
  {
    id: 'brain-fuel-nootropic',
    name: 'Brain Fuel Nootropic Blend',
    slug: 'brain-fuel-nootropic',
    sku: 'KV-EF-002',
    price: 68.75,
    image: productImages.brainBooster,
    categoryId: 'energy-focus',
    categorySlug: 'energy-focus',
    description: 'Advanced nootropic formula for cognitive function, focus, and memory.',
    features: ['Lion\'s Mane', 'Enhanced Focus', 'Memory Support', 'Alpha-GPC'],
    inStock: true
  },
  {
    id: 'keto-probiotics-40b',
    name: 'Keto Probiotics 40 Billion CFU',
    slug: 'keto-probiotics-40b',
    sku: 'KV-DH-001',
    price: 47.50,
    image: productImages.probioticsKeto,
    badge: 'Best Seller',
    categoryId: 'digestive-health',
    categorySlug: 'digestive-health',
    description: 'High-potency probiotic formula with 40 billion CFU for gut health on keto.',
    features: ['40 Billion CFU', '15 Strains', 'Shelf Stable', 'Gut Health'],
    inStock: true
  },
  {
    id: 'digestive-enzyme-complex',
    name: 'Digestive Enzyme Complex',
    slug: 'digestive-enzyme-complex',
    sku: 'KV-DH-002',
    price: 38.95,
    image: productImages.digestiveEnzymes,
    categoryId: 'digestive-health',
    categorySlug: 'digestive-health',
    description: 'Comprehensive enzyme blend to support fat digestion on keto.',
    features: ['Lipase & Protease', 'Ox Bile Extract', 'Fat Digestion', 'Reduces Bloating'],
    inStock: true
  },
  {
    id: 'keto-multivitamin',
    name: 'Complete Keto Multivitamin',
    slug: 'keto-multivitamin',
    sku: 'KV-VM-001',
    price: 44.20,
    image: productImages.ketoMultivitamin,
    categoryId: 'vitamins-minerals',
    categorySlug: 'vitamins-minerals',
    description: 'Comprehensive multivitamin formula for ketogenic diets.',
    features: ['22 Vitamins & Minerals', 'Keto-Optimized', 'No Carbs', 'Antioxidants'],
    inStock: true
  },
  {
    id: 'vitamin-d3-k2',
    name: 'Vitamin D3 + K2 Complex',
    slug: 'vitamin-d3-k2',
    sku: 'KV-VM-002',
    price: 28.60,
    image: productImages.vitaminD3K2,
    badge: 'Essential',
    categoryId: 'vitamins-minerals',
    categorySlug: 'vitamins-minerals',
    description: 'High-potency Vitamin D3 with K2 for bone health and immune support.',
    features: ['5000 IU D3', 'K2 MK-7 Form', 'Bone Health', 'Immune Support'],
    inStock: true
  },
  {
    id: 'keto-sleep-support',
    name: 'Keto Sleep Support Formula',
    slug: 'keto-sleep-support',
    sku: 'KV-WB-001',
    price: 33.45,
    image: productImages.sleepSupport,
    categoryId: 'wellness-blends',
    categorySlug: 'wellness-blends',
    description: 'Natural sleep support with magnesium, L-theanine, and melatonin.',
    features: ['Magnesium Glycinate', 'L-Theanine', 'Melatonin', 'Non-Habit Forming'],
    inStock: true
  },
  {
    id: 'immune-defense-blend',
    name: 'Immune Defense Blend',
    slug: 'immune-defense-blend',
    sku: 'KV-WB-002',
    price: 51.75,
    image: productImages.immuneBoost,
    badge: 'Popular',
    categoryId: 'wellness-blends',
    categorySlug: 'wellness-blends',
    description: 'Powerful immune support with Vitamin C, Zinc, Elderberry, and Echinacea.',
    features: ['Vitamin C & Zinc', 'Elderberry Extract', 'Echinacea', 'Daily Defense'],
    inStock: true
  },
  // ============================================
  // PREMIUM BUNDLES & VALUE PACKS
  // ============================================
  {
    id: 'keto-starter-bundle-3mo',
    name: '3-Month Keto Starter Bundle',
    slug: 'keto-starter-bundle-3mo',
    sku: 'KV-BD-001',
    price: 149.95,
    image: productImages.bhbKetones,
    badge: 'Value Pack',
    categoryId: 'bundles-value-packs',
    categorySlug: 'bundles-value-packs',
    description: 'Kickstart your keto journey with a 3-month supply of our two best sellers: BHB Ketone Capsules and Keto Electrolyte Complex. Save vs buying individually.',
    features: ['3-Month Supply', '2 Best-Selling Products', 'Save Over 15%', 'Free USA Shipping'],
    inStock: true
  },
  {
    id: 'complete-wellness-stack-6mo',
    name: '6-Month Complete Wellness Stack',
    slug: 'complete-wellness-stack-6mo',
    sku: 'KV-BD-002',
    price: 279.95,
    image: productImages.ketoMultivitamin,
    badge: 'Most Popular',
    categoryId: 'bundles-value-packs',
    categorySlug: 'bundles-value-packs',
    description: 'A 6-month supply of our Complete Keto Multivitamin, MCT Oil Softgels, and Keto Electrolytes. Everything you need for sustained ketogenic wellness.',
    features: ['6-Month Supply', '3 Core Products', 'Save Over 20%', 'Premium Quality'],
    inStock: true
  },
  {
    id: 'annual-bhb-mega-supply',
    name: 'Annual BHB Mega Supply (12-Month)',
    slug: 'annual-bhb-mega-supply',
    sku: 'KV-BD-003',
    price: 549.95,
    image: productImages.bhbKetones,
    badge: 'Best Value',
    categoryId: 'bundles-value-packs',
    categorySlug: 'bundles-value-packs',
    description: 'Full 12-month supply of our flagship BHB Ketone Capsules - Advanced Formula. The ultimate commitment to your ketogenic lifestyle at maximum savings.',
    features: ['12-Month Supply', '12 Bottles Included', 'Save Over 25%', 'Lock-In Pricing'],
    inStock: true
  },
  {
    id: 'family-wellness-kit',
    name: 'Family Wellness Kit (4-Person, 3-Month)',
    slug: 'family-wellness-kit',
    sku: 'KV-BD-004',
    price: 399.95,
    image: productImages.immuneBoost,
    categoryId: 'bundles-value-packs',
    categorySlug: 'bundles-value-packs',
    description: 'Designed for households on keto. 3-month supply of multivitamins, immune defense, vitamin D3+K2, and electrolytes for up to 4 family members.',
    features: ['Up to 4 People', '3-Month Supply', 'Immune + Daily Support', 'Family Savings'],
    inStock: true
  },
  {
    id: 'keto-vybe-pro-bundle',
    name: 'Keto Vybe Pro Bundle - All 12 Products',
    slug: 'keto-vybe-pro-bundle',
    sku: 'KV-BD-005',
    price: 449.95,
    image: productImages.brainBooster,
    badge: 'Pro',
    categoryId: 'bundles-value-packs',
    categorySlug: 'bundles-value-packs',
    description: 'The complete Keto Vybe collection - one of every supplement we offer. Perfect for serious keto enthusiasts who want the full stack experience.',
    features: ['All 12 Products', '1-Month Supply Each', 'Save Over 30%', 'Limited Edition Box'],
    inStock: true
  },
  {
    id: 'wholesale-bulk-pack',
    name: 'Wholesale Bulk Pack - 12-Month Wellness',
    slug: 'wholesale-bulk-pack',
    sku: 'KV-BD-006',
    price: 899.95,
    image: productImages.thermogenicBlend,
    badge: 'Wholesale',
    categoryId: 'bundles-value-packs',
    categorySlug: 'bundles-value-packs',
    description: 'Our largest premium pack: 12-month supply across our top 6 supplements. Ideal for long-term commitment, gift-giving, or wholesale buyers.',
    features: ['12-Month Premium Supply', '6 Top Products', 'Maximum Savings', 'White-Glove Packaging'],
    inStock: true
  }
];

// ============================================
// FEATURES
// ============================================
export const features = [
  { id: 1, title: 'Keto-Optimized', description: 'Formulas designed for ketogenic success' },
  { id: 2, title: 'Premium Quality', description: 'Third-party tested for purity' },
  { id: 3, title: 'Science-Backed', description: 'Based on latest research' },
  { id: 4, title: 'Fast Shipping', description: 'Free shipping on $99+' }
];

// ============================================
// STEPS
// ============================================
export const steps = [
  { id: 1, title: 'Browse', description: 'Explore our keto supplements' },
  { id: 2, title: 'Choose', description: 'Select based on your goals' },
  { id: 3, title: 'Order', description: 'Secure checkout process' },
  { id: 4, title: 'Thrive', description: 'Feel the difference' }
];
